const commonAuditActions = [
    'DESCRIPTOR_RESOLVED', 'ACCESS_DENIED', 'QUERY_EXECUTED', 'CREATE', 'UPDATE', 'SUBMIT', 'APPROVE', 'REJECT', 'POST', 'REVERSE', 'IMPORT', 'EXPORT', 'REPORT_RUN', 'ARTIFACT_DOWNLOAD', 'DELEGATION_START', 'DELEGATION_END', 'PRIVILEGED_ACCESS',
    'FORM_VALIDATION', 'OPTIMISTIC_CONFLICT', 'DASHBOARD_QUERY', 'MARKET_DATA_FEED', 'STALE_PRICE_DETECTED', 'MISSING_PRICE_DETECTED', 'MAPPING_FAILURE', 'RECONCILIATION_BREAK', 'COMPLIANCE_BREACH', 'OUTBOX_BACKLOG', 'RLS_DENIAL',
];
export const DEFAULT_FINANCIAL_AUDIT_POLICY = Object.freeze({
    domain: 'PORTFOLIO_MANAGEMENT',
    actions: commonAuditActions,
    includeDecisionId: true,
    includeOperationId: true,
    includeScopeFingerprint: true,
    includeRecordIds: true,
    redactSensitiveFields: true,
    immutable: true,
});
export const FINANCIAL_OUTBOX_POLICIES = Object.freeze([
    { domain: 'TRANSACTION_MANAGEMENT', mutationEventTypes: ['transaction.created', 'transaction.submitted', 'transaction.approved', 'transaction.posted', 'transaction.reversed'], sameTransactionRequired: true, idempotentConsumersRequired: true, maximumAttempts: 10, abandonedAfterHours: 24, preserveOrderingByAggregate: true },
    { domain: 'ACCOUNTING', mutationEventTypes: ['journal.posted', 'journal.reversed', 'period.closed', 'period.reopened'], sameTransactionRequired: true, idempotentConsumersRequired: true, maximumAttempts: 10, abandonedAfterHours: 24, preserveOrderingByAggregate: true },
    { domain: 'RECONCILIATION', mutationEventTypes: ['reconciliation.started', 'break.assigned', 'break.resolved', 'adjustment.approved'], sameTransactionRequired: true, idempotentConsumersRequired: true, maximumAttempts: 10, abandonedAfterHours: 24, preserveOrderingByAggregate: true },
    { domain: 'CORPORATE_ACTIONS', mutationEventTypes: ['corporate-action.received', 'entitlement.calculated', 'election.recorded', 'corporate-action.processed'], sameTransactionRequired: true, idempotentConsumersRequired: true, maximumAttempts: 10, abandonedAfterHours: 24, preserveOrderingByAggregate: true },
    { domain: 'REGULATORY_REPORTING', mutationEventTypes: ['report.requested', 'report.generated', 'report.validated', 'report.submitted', 'artifact.created'], sameTransactionRequired: true, idempotentConsumersRequired: true, maximumAttempts: 10, abandonedAfterHours: 24, preserveOrderingByAggregate: true },
]);
export const DEFAULT_FINANCIAL_OBSERVABILITY_POLICY = Object.freeze({
    domain: 'PORTFOLIO_MANAGEMENT',
    metricDimensions: ['routeId', 'operationId', 'resourceId', 'reportId', 'dashboardId', 'resultState', 'scopeKind'],
    prohibitedMetricDimensions: ['userId', 'organizationId', 'branchId', 'clientAccountId', 'portfolioAccountId', 'recordId', 'boid', 'pan'],
    traceAttributes: ['decisionId', 'routeId', 'operationId', 'module', 'scopeKind', 'delegated'],
    prohibitedLogFields: ['password', 'token', 'secret', 'authorization', 'boid', 'pan', 'bankAccount', 'providerSecret', 'signedUrl'],
});
export const DEFAULT_FINANCIAL_ACCESSIBILITY_POLICY = Object.freeze({
    semanticTableRequired: true,
    keyboardNavigationRequired: true,
    visibleFocusRequired: true,
    formErrorSummaryRequired: true,
    linkedFieldErrorsRequired: true,
    chartTextAlternativeRequired: true,
    nonColorStatusRequired: true,
    zoomSupported: true,
    reducedMotionSupported: true,
});
export const DEFAULT_FINANCIAL_PRIVACY_POLICY = Object.freeze({
    hiddenDescriptorsAbsent: true,
    fieldProjectionRequired: true,
    clientIdentifiersMasked: true,
    storageUrlsPrivate: true,
    signedDownloadRequired: true,
    cacheKeysScopeAware: true,
    browserBackDisclosurePreventedForDelegation: true,
});
export function validateFinancialOperationalHardeningPolicies() {
    const errors = [];
    if (!DEFAULT_FINANCIAL_AUDIT_POLICY.immutable)
        errors.push('financial audit must be immutable');
    if (!DEFAULT_FINANCIAL_AUDIT_POLICY.redactSensitiveFields)
        errors.push('financial audit must redact sensitive fields');
    for (const policy of FINANCIAL_OUTBOX_POLICIES) {
        if (!policy.sameTransactionRequired)
            errors.push(`${policy.domain}: outbox event must be written in the mutation transaction`);
        if (!policy.idempotentConsumersRequired)
            errors.push(`${policy.domain}: outbox consumers must be idempotent`);
        if (policy.maximumAttempts < 1)
            errors.push(`${policy.domain}: maximumAttempts must be positive`);
    }
    if (!DEFAULT_FINANCIAL_PRIVACY_POLICY.hiddenDescriptorsAbsent)
        errors.push('hidden descriptors must be absent');
    if (!DEFAULT_FINANCIAL_ACCESSIBILITY_POLICY.chartTextAlternativeRequired)
        errors.push('charts require text alternatives');
    return errors;
}
